const Contact = () => import(/* webpackChunkName: "auth" */ '@/modules/contact/views/ContactUs')


export default [
  {
    path: '/contact-us',
    name: 'Contact Us',
    component: Contact
  }
]
